<script setup lang="ts">

import {CallToActionSettings} from "@/SocialWidget/types/call_to_action_types";
import {onMounted, onUnmounted, ref} from "vue";
import CallToModalWindow from "@/Pages/SocialWidget/Widget/Components/CallToModal/CallToModalWindow.vue";
import CallToModalWidget from "@/Pages/SocialWidget/Widget/Components/CallToModal/CallToModalWidget.vue";
import MobileCallToModalWidget from "@/Pages/SocialWidget/Widget/Components/CallToModal/MobileCallToModalWidget.vue";
import MobileCallToModalWindow from "@/Pages/SocialWidget/Widget/Components/CallToModal/MobileCallToModalWindow.vue";
import {emitStatsEvent} from "@/utils";

const props = defineProps<{
    settings: CallToActionSettings,
    endpoint?: string,
    widgetId?: string,
    counters?: any,
}>();

const isShow = ref(false);
const isShowWidget = ref(false);

const showWidget = () => {
    switch (props.settings.widget_adaptive_show ?? 'all') {
        case 'all':
            break;
        case 'pc':
            if (window.matchMedia("(max-width: 767px)").matches) {
                return;
            }
            break;
        case 'mobile':
            if (!window.matchMedia("(max-width: 767px)").matches) {
                return;
            }
            break;
    }
    const lastShownKey = 'dg-ctw-last-shown-'+ props.widgetId;
    const lastShown = localStorage.getItem(lastShownKey);
    if (lastShown && (Date.now() - Number(lastShown)) < (60 * 60 * 1000)) {
        return;
    }
    isShowWidget.value = true;
    localStorage.setItem(lastShownKey, Date.now().toString());

}

const showModal = () => {
    if (props.settings.popup_enabled) {

        switch (props.settings.adaptiveShow ?? 'all') {
            case 'all':
                break;
            case 'pc':
                if (window.matchMedia("(max-width: 767px)").matches) {
                    return;
                }
                break;
            case 'mobile':
                if (!window.matchMedia("(max-width: 767px)").matches) {
                    return;
                }
                break;
        }
        const lastShownKey = 'dg-cta-last-shown-'+ props.widgetId;
        const lastShown = localStorage.getItem(lastShownKey);
        if (lastShown && (Date.now() - Number(lastShown)) < (60 * 60 * 1000)) {
            return;
        }
        isShow.value = true;
        localStorage.setItem(lastShownKey, Date.now().toString());
    }
};
const trackView = () => {
    const lastShownKey = 'dg-modal-last-visit-'+ props.widgetId;
    const lastShown = localStorage.getItem(lastShownKey);
    if (lastShown && (Date.now() - Number(lastShown)) < (24 * 360 * 1000)) {
        return;
    }
    localStorage.setItem(lastShownKey, Date.now().toString());
    fetch(`${props.endpoint}/${props.widgetId}/track/view?type=modal`, {method: 'post'});
}


onMounted(() => {
    if (props.settings.showModalOnLeaving) {
        document.addEventListener('mouseleave', showModal);
    }
    if (props.settings.widget_show_leaving) {
        document.addEventListener('mouseleave', showWidget);
    }
});

onUnmounted(() => {
    if (props.settings.showModalOnLeaving) {
        document.removeEventListener('mouseleave', showModal);
    }
    if (props.settings.widget_show_leaving) {
        document.removeEventListener('mouseleave', showWidget);
    }
});

const widgetClick = () => {
    if (props.settings.widget_button_type === 'custom') {
        emitStatsEvent('dg_widget_click', props.counters);
        fetch(`${props.endpoint}/${props.widgetId}/redirect-custom`);
        window.open(props.settings.widget_button_link,'_blank');
    }
    if (props.settings.widget_button_type === 'modal') {
        emitStatsEvent('dg_widget_open', props.counters);
        isShow.value = true;
        isShowWidget.value = false;
    }
}
setTimeout(trackView, 2000);
setTimeout(showModal, props.settings.modalDisplayDelay * 1000);
setTimeout(showWidget, props.settings.widget_display_delay * 1000);

const positionStyles = () => {
    if(props.settings !== null) {
        let res = {
            bottom: `20px`,
            right: '',
            left: '',
        };
        if (props.settings.widget_position === 'left') {
            res['left'] = `20px`;
        }
        if (props.settings.widget_position === 'right') {
            res['right'] = `20px`;
        }
        return res;
    }
}

</script>

<template>
    <div v-if="isShow" style="z-index: 999998" class="fixed  top-[20%] flex w-full justify-center">

        <MobileCallToModalWindow :settings="settings"
                                 :endpoint="endpoint"
                                 :widget-id="widgetId"
                                 :counters="counters"
                                 style="z-index: 999998"
                                 @close="isShow = false"
                                 class="dg_modal-animation grid md:hidden"/>
        <CallToModalWindow :settings="settings"
                           class="dg_modal-animation hidden md:grid"
                           style="z-index: 999998"
                           @close="isShow = false"
                           :endpoint="endpoint"
                           :counters="counters"
                           :widget-id="widgetId"/>
    </div>

    <div class="fixed" :class="[props.settings.widget_position === 'center' ? 'flex w-full justify-center' : '']" :style="positionStyles()"
         style="z-index: 999997"
         v-if="isShowWidget && settings.widget_enabled">

        <MobileCallToModalWidget @open-modal="widgetClick"
                                 @close="isShowWidget = false"
                                 :settings="settings"
                                 class="dg_widget-popup-animation block md:hidden"
                                 style="z-index: 999997"/>

        <CallToModalWidget :settings="settings" class="dg_widget-popup-animation hidden md:block"
                           @close="isShowWidget = false"
                           @open-modal="widgetClick"
                           style="z-index: 999997"/>

    </div>
</template>

<style scoped>

</style>
